import Navigation from "@/components/Navigation";
import Footer from "@/components/Footer";

const Cookies = () => {
  return (
    <div className="min-h-screen bg-background text-foreground">
      <Navigation />
      <main className="pt-32 pb-24">
        <div className="container-luxury max-w-3xl">
          <h1 className="font-display text-3xl md:text-4xl tracking-wider text-foreground mb-16 text-center">
            Cookie Policy
          </h1>

          <div className="space-y-10 font-body text-foreground/70 text-sm leading-[1.9]">
            <section>
              <h2 className="font-display text-foreground text-base tracking-wider mb-4">1. What Are Cookies</h2>
              <p>1.1 Cookies are small text files placed on your device when you visit a website. They help the website recognise your device and remember certain information about your visit.</p>
              <p className="mt-2">1.2 Cookies are widely used to make websites work more efficiently and to provide information to website owners.</p>
            </section>

            <section>
              <h2 className="font-display text-foreground text-base tracking-wider mb-4">2. How We Use Cookies</h2>
              <p>2.1 Arzani Group Worldwide ("Arzani") uses cookies to:</p>
              <ul className="list-disc list-inside mt-2 space-y-1 ml-4">
                <li>Ensure the website functions correctly</li>
                <li>Improve your browsing experience</li>
                <li>Analyse website traffic and usage patterns</li>
                <li>Remember your preferences</li>
              </ul>
            </section>

            <section>
              <h2 className="font-display text-foreground text-base tracking-wider mb-4">3. Types of Cookies We Use</h2>
              <p>3.1 <strong className="text-foreground/90">Essential Cookies:</strong> Required for the website to function properly. These cannot be disabled.</p>
              <p className="mt-2">3.2 <strong className="text-foreground/90">Analytics Cookies:</strong> Help us understand how visitors interact with our website by collecting anonymous usage data.</p>
              <p className="mt-2">3.3 <strong className="text-foreground/90">Functional Cookies:</strong> Allow the website to remember choices you make (such as language or region) to provide a more personalised experience.</p>
              <p className="mt-2">3.4 <strong className="text-foreground/90">Marketing Cookies:</strong> May be used to deliver relevant content or advertisements based on your browsing behaviour.</p>
            </section>

            <section>
              <h2 className="font-display text-foreground text-base tracking-wider mb-4">4. Third-Party Cookies</h2>
              <p>4.1 Some cookies may be set by third-party services that appear on our pages, such as analytics providers or social media platforms.</p>
              <p className="mt-2">4.2 Arzani does not control the use of third-party cookies and recommends reviewing the respective privacy policies of those providers.</p>
            </section>

            <section>
              <h2 className="font-display text-foreground text-base tracking-wider mb-4">5. Managing Cookies</h2>
              <p>5.1 You can manage or disable cookies through your browser settings at any time.</p>
              <p className="mt-2">5.2 Please note that disabling certain cookies may affect the functionality of the website.</p>
              <p className="mt-2">5.3 For more information on managing cookies, visit your browser's help section or{" "}
                <a href="https://www.allaboutcookies.org" target="_blank" rel="noopener noreferrer" className="text-foreground/90 underline underline-offset-4 hover:text-foreground transition-colors duration-500">
                  www.allaboutcookies.org
                </a>.
              </p>
            </section>

            <section>
              <h2 className="font-display text-foreground text-base tracking-wider mb-4">6. Consent</h2>
              <p>6.1 By continuing to use our website, you consent to the use of cookies as described in this policy.</p>
              <p className="mt-2">6.2 You may withdraw your consent at any time by adjusting your browser settings.</p>
            </section>

            <section>
              <h2 className="font-display text-foreground text-base tracking-wider mb-4">7. Changes to This Policy</h2>
              <p>7.1 Arzani reserves the right to update this Cookie Policy when necessary.</p>
              <p className="mt-2">7.2 The most recent version will always be available on our website.</p>
            </section>

            <section>
              <h2 className="font-display text-foreground text-base tracking-wider mb-4">8. Contact</h2>
              <p>8.1 For questions regarding our use of cookies, please contact us at{" "}
                <a href="mailto:info@arzanigroupworldwide.com" className="text-foreground/90 underline underline-offset-4 hover:text-foreground transition-colors duration-500">
                  info@arzanigroupworldwide.com
                </a>.
              </p>
            </section>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Cookies;
